//// ********** ********** ********** ********** **********

$(document).ready(() => {

  const audioElems = $('audio');
  const rBooksElem = $('#rBooks');

  audioElems.on('ended', onAudioEndedClick);
  audioElems.on('play', onAudioPlayClick);
  rBooksElem.on('load', onRBooksElemLoad);

  // ********** **********
  function onAudioEndedClick(event) {
    let flag = 0;
    audioElems.each((index, audioElem) => {
      if (audioElem == event.target) {
        flag = 1;
      }
      else if (flag == 1) {
        audioElem.play();
        flag = 2;
        return false;
      }
    });
  }

  // ********** **********
  function onAudioPlayClick(event) {
    audioElems.each((index, audioElem) => {
      if (audioElem != event.target) {
        audioElem.pause();
      }
    });
  }

  // ********** **********
  function onButtonFullPageClick() {
    rBooksElem.toggleClass('full-page-control');
  }

  // ********** **********
  function onRBooksElemLoad() {
    const buttonFullPage = $(this).contents().find('#rbooks2FullPageToggleButton');
    buttonFullPage.show();
    buttonFullPage.click((event) => {
      onButtonFullPageClick();
    });
  }

  // ********** **********
});